import { useMutation, useQuery } from '@tanstack/react-query';
import type { ConnectionDto } from '@rw/shared';
import { ApiError, api } from '../../lib/api';
import { toast } from '../../stores/toasts';

export function useConnections() {
  return useQuery({ queryKey: ['connections'], queryFn: () => api<ConnectionDto[]>('/integrations') });
}

/** Starts the Strava OAuth round-trip (shared by Home and Profile). */
export function useStravaConnect() {
  return useMutation({
    mutationFn: () => api<{ url: string }>('/integrations/strava/authorize', { method: 'POST' }),
    onSuccess: ({ url }) => window.location.assign(url),
    onError: (e) => toast({ kind: 'error', title: e instanceof ApiError ? e.message : 'Could not start Strava login' }),
  });
}
